/**
 * Created by Ding on 12/04/2017.
 */

import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { Button, Icon, Modal } from 'antd';
import cookie from 'react-cookie';
import faceMail from '../../images/face-mail.svg';

import { ajaxGet } from '../../utils/ajax';

const JobStatus = {
    waitingPublish: 1, // 待发布
    published: 2, // 已发布
    canceled: 3, // 已取消
    paused: 4, // 已暂停
    closed: 5, // 已关闭
};

export default class Position extends Component {

    static propTypes = {
        params: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
    };

    state = {
        position: {},
        isShow: true,
    };

    componentDidMount() {
        this.getPosition();
        this.getJudge();
    }

    getPosition = () => {
        ajaxGet(`/recruit/api/hunter/findJdInfoDetail/${this.props.params.positionId}`, {}, (rawData) => {
            this.setState({
                position: rawData.data,
            });
            document.title = rawData.data.jobName;
        });
    };

    getJudge = () => {
        ajaxGet(`/recruit/api/hunter/judge/jdInfo/${this.props.params.positionId}?email=${cookie.load('cookie_user_en')}`, {}, (rawData) => {
            if (!rawData.data) {
                Modal.warning({
                    content: '职位已关闭',
                });
                this.setState({
                    isShow: false
                })
            }
        });
    };

    columns = [
        { name: '发布时间', key: 'createTime' },
        { name: '到岗日期', key: 'onboardingDate' },
        { name: '刷新时间', key: 'refreshTime' },
        { name: '招聘人数', key: 'quantity' },
        { name: '工作地点', key: 'workArea' },
        // { name: '薪资范围', key: 'salaryMin' },
    ];

    columns2 = [
        { name: '工作职责', key: 'jobDuty' },
        { name: '任职资格', key: 'jobQualification' },
        { name: '寻访要求', key: 'remark' },
        { name: '招聘HR', key: 'hrName' },
    ];

    render() {
        return (
            <div>
                {
                    [JobStatus.paused, JobStatus.canceled, JobStatus.closed].includes(this.state.position.status) ? <p className="notice">
                        职位广告已下线，如您已推荐候选人到当前职位并还处于流程中，建议邮件联系招聘HR沟通处理
                    </p> : null
                }
                <h1 className="detail-page-title">{`${this.state.position.jobName}(${this.state.position.jdNo})`}</h1>
                <div className="panel">
                    {this.columns.map((item, itemKey) => (
                        <p
                            key={item.key}
                            style={{
                                marginBottom: '20px',
                                display: itemKey === 0 || itemKey === 1 || itemKey === 2 ? 'inline-block' : 'block',
                                marginLeft: itemKey === 1 || itemKey === 2 ? '170px' : 0,
                            }}
                        >
                            <span style={{ display: 'inline-block', width: '60px', textAlign: 'right' }}>
                                {item.name}:
                            </span>
                            <span style={{ marginLeft: '10px' }}>
                                {
                                    this.state.position[item.key]
                                }
                                {/* {itemKey === 4 && `-${this.state.position.salaryMax}`} */}
                            </span>
                        </p>
                    ))}

                    {this.columns2.map((item, itemKey) => (
                        <div
                            key={item.key}
                            style={{
                                marginBottom: itemKey === this.columns.length - 1 ? 0 : '20px',
                            }}
                        >
                            <span
                                style={{
                                    display: 'inline-block',
                                    verticalAlign: 'top',
                                    width: '60px',
                                    textAlign: 'right',
                                }}
                            >
                                {item.name}:
                            </span>
                            <div
                                style={{
                                    display: 'inline-block',
                                    verticalAlign: 'top',
                                    width: 'calc(100% - 70px)',
                                    marginLeft: '10px',
                                }}
                            >
                                {this.state.position[item.key] ? this.state.position[item.key].split(/\r\n|\n|\r/)
                                    .map((line) => {
                                        if (item.key === 'hrName') {
                                            return <p key={Math.random()} style={{display: 'flex'}}><span>{line}</span><img style={{width: '20px', margin: '-1px 5px 0 10px'}} src={faceMail} alt=""/>{this.state.position.hrEmail}<span style={{marginLeft: '5px', color: '#c1c1c1'}}>（邮件沟通时，请备注咨询的职位名称及编号）</span></p>
                                        }
                                        return <p key={Math.random()}>{line}</p>
                                    }) : ''}
                            </div>
                        </div>
                    ))}
                </div>

                {
                    [JobStatus.paused, JobStatus.canceled, JobStatus.closed].includes(this.state.position.status) ? null : <div style={{ textAlign: 'center' }}>
                        <Button onClick={() => this.props.history.goBack()}>返回</Button>
                        {this.state.position.status === 2 && this.state.isShow &&
                        <Link to={`/position_${this.state.position.jdId}/recommend_candidate`}>
                            <Button type="primary" style={{ marginLeft: '20px' }}>
                                推荐候选人
                            </Button>
                        </Link>}
                    </div>
                }
            </div>
        );
    }
}
